import React from 'react';
import { Alert, Col, Container, ProgressBar, Row } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import Skeleton from 'react-loading-skeleton';

import WaitingRoomViewSkeleton from './WaitingRoomViewSkeleton';
import { WAITING_ROOM_RUNNING_STATUS } from '../api/config';

import 'react-loading-skeleton/dist/skeleton.css';

const WaitingRoomView = ({ waitingRoom }) => {
    if (!waitingRoom || Object.keys(waitingRoom).length === 0) {
        return <WaitingRoomViewSkeleton />;
    }

    const { title, position, nextInQueue } = waitingRoom;

    return (
        <>
            <Container className='waiting-room-view-container'>
                <Row>
                    <Col xl={{ span: 6, offset: 3 }} lg={{ span: 8, offset: 2 }} md={12} sm={12}>
                        <div className="bg-white p-4 rounded-3 mt-5 mb-5 text-center">
                            <h2 className="fw-bold mt-3 mb-3">
                                {waitingRoom.status ? getTitleText(nextInQueue, waitingRoom) : <Skeleton />}
                            </h2>
                            <p className="fw-bold mb-4">{title || <Skeleton />}</p>
                            <div className="mx-auto text-center mb-3">
                                <p className={`${nextInQueue ? 'text-primary fw-bold' : ''} mb-4`}>
                                    {waitingRoom.status ? getSubtitleText(nextInQueue, waitingRoom) : <Skeleton />}
                                </p>
                                {nextInQueue && <div className="loading-spinner" />}
                            </div>
                            {waitingRoom.status ? getStatusAlert(waitingRoom) : <Skeleton />}
                            {!nextInQueue && (
                                <div className='mt-4'>
                                    <div className="d-flex gap-2">
                                        <div className="waiting-room-col">
                                            <div className="block__waiting p-md-3 rounded-3">
                                                <h2 className="text-primary fw-bold mb-3">
                                                    {position ? position - 1 : '--'} <FormattedMessage id='waiting_room_info_1_1' />
                                                </h2>
                                                <p><FormattedMessage id='waiting_room_info_1' /></p>
                                            </div>
                                        </div>
                                        <div className="waiting-room-col">
                                            <div className="block__waiting p-md-3 rounded-3">
                                                <h2 className="text-primary fw-bold mb-3">
                                                    {waitingRoom.status === WAITING_ROOM_RUNNING_STATUS ? waitingRoom.waitTime : '--'}
                                                </h2>
                                                <p><FormattedMessage id='waiting_room_info_2'/></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            <div className="progress-container mt-5">
                                <ProgressBar now={waitingRoom.queueProgress} />
                                <span className="progress-bar__pointer" style={waitingRoom.queueProgress > 50
                                    ? { left: 'auto', right: `${99.5 - waitingRoom.queueProgress}%` }
                                    : { left: `${waitingRoom.queueProgress}%` }
                                }></span>
                            </div>
                            <p className="mt-5 fs-sm text-body-tertiary"><FormattedMessage id='waiting_room_footer'/></p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

const getTitleText = (nextInQueue, waitingRoom) => (
    (nextInQueue && waitingRoom.status === WAITING_ROOM_RUNNING_STATUS)
        ? <FormattedMessage id='waiting_room_header_next'/>
        : <FormattedMessage id='waiting_room_header'/>
);

const getSubtitleText = (nextInQueue, waitingRoom) => (
    (nextInQueue && waitingRoom.status === WAITING_ROOM_RUNNING_STATUS)
        ? <FormattedMessage id='waiting_room_subtitle_next'/>
        : <FormattedMessage id='waiting_room_subtitle_2'/>
);

const getStatusAlert = (waitingRoom) => ((waitingRoom.status !== WAITING_ROOM_RUNNING_STATUS) && (
    <Alert variant="light" className="alert__waiting-room border border-primary mt-3 mb-3">
        <FormattedMessage id='waiting_room_stopped_warning'/>
    </Alert>
));

export default WaitingRoomView;
